<template>
  <div>
    <div class="container-fluid">
      <h2>Willkommen <span class="text-primary">{{
          $store.getters.getUser.sFirstname
        }} {{ $store.getters.getUser.sLastname }}</span></h2>

      <div class="row mt-4">
        <div v-for="(card,idx) in cards" :key="idx" class="col-xl-3 col-md-6">
          <div class="card h-80 mb-4" :class="card.sClass">
            <div class="card-body">
              <div v-html='card.sContent'></div>
            </div>
            <div v-if="card.sLink" class="card-footer d-flex align-items-center justify-content-between">
              <router-link class="small text-white stretched-link" :to="card.sLink">mehr erfahren</router-link>
              <div class="small text-white"><i class="fas fa-angle-right"></i></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div v-if="permissionOwnTask" class="col-xl-6">
          <div class="row">
            <div class="col-12">
              <div class="card mb-4">
                <div class="card-header">
                  <i class="fas fa-info mr-1"></i>
                  Neueste Infos
                </div>
                <div class="card-body">
                  <DashboardInfos></DashboardInfos>
                </div>
                <div class="card-footer bg-light">
                  <router-link class="small" style="text-align: right" to="/myinfo">Details unter <i>Informationen</i>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-6">
          <div class="row">
            <div class="col-12">
              <div class="card mb-4">
                <div class="card-header">
                  <i class="fas fa-calendar-check mr-1"></i>
                  Eigener Terminstatus
                </div>
                <div class="card-body">
                  <DashboardDates></DashboardDates>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import DashboardInfos from '../components/DashboardInfos'
import UserService from '../services/UserService'
import DashboardDates from '../components/DashboardDates'
import store from '@/store'

export default {
  components: {
    DashboardDates,
    DashboardInfos
  },
  async mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.permissionOwnTask = this.$store.getters.hasPermission(this.$module.IDENTIFIER_Info, this.$permission.RECHT_Access_Own)

      var tmp = await UserService.getDashboard()
      this.cards = tmp.data
      store.dispatch('menu/setLoading', false)
    }
  },
  computed: {
    getLocation () {
      return this.$store.getters.getLocation
    }
  },
  watch: {
    'getLocation' () {
      this.init()
    }
  },
  data () {
    return {
      key: 0,
      showPoints: false,
      cards: [],
      permissionOwnTask: false
    }
  }
}
</script>

<style scoped>

.h-80 {
  height: 80% !important;
}

.bg-warning {
  background-color: rgba(255, 193, 7, 0.8) !important;
}

.bg-danger {
  background-color: rgba(220, 53, 69, 0.8) !important;
}

.bg-success {
  background-color: rgba(40, 167, 69, 0.8) !important;
}
</style>
